import { useEffect, useRef } from 'react';
import { useMapUtils } from '@shapeable/maps';
import { useReady } from '@shapeable/ui';

export const MapDeepLinkHandler = (): null => {
  const isReady = useReady();
  const { show } = useMapUtils();
  const handled = useRef(false);

  useEffect(() => {
    if (!isReady || handled.current || typeof window === 'undefined') {
      return;
    }

    const params = new URLSearchParams(window.location.search);

    if (params.get('map') !== 'open') {
      return;
    }

    handled.current = true;
    params.delete('map');

    const search = params.toString();
    const url = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`;

    window.history.replaceState(null, '', url);
    show();
  }, [isReady, show]);

  return null;
};
